import { useState, useCallback } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface ToteDetailsResponse {
  tote: string;
}

export const useToteDetails = (selectedHeaderToOrg?: string, pallet?: string, cage?: string, enabled: boolean = true) => {
  const [data, setData] = useState<ToteDetailsResponse[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async (toOrg?: string, palletVal?: string, cageVal?: string, toteVal?: string, callback?: (data: ToteDetailsResponse[]) => void) => {
    if (!enabled || !toOrg || !palletVal || !cageVal) {
      setData([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { data: responseData } = await apiClient.get(
        API_CONFIG.ENDPOINTS.GET_TOTE_DETAILS,
        {
          params: {
            tosite: toOrg,
            palletval: palletVal,
            cageval: cageVal,
            ...(toteVal && { toteval: toteVal })
          }
        }
      );
      
      if (responseData.success) {
        const toteData = responseData.data || [];
        setData(toteData);
        if (callback) {
          callback(toteData);
        }
      } else {
        throw new Error(responseData.error || 'Failed to fetch tote details');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
      console.error('Error fetching tote details:', err);
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  return {
    data,
    loading,
    error,
    refetch
  };
};